const {getUpdatedModel} = require('od-modules/models/common/search_summary_utils.js');
var currentSearchSingletonModel = require('od-modules/models/current_search.singleton.model');

const getUserInfo = (userData) => {
    let isLogged;
    let isPrime;
    let isActive = false;

    if (Odigeo._.isNull(userData)) {
        const rememberMeCookie = Odigeo.Utils.readCookie('sso_remember_me');
        isLogged = !Odigeo._.isNull(rememberMeCookie);
        isPrime = isLogged && Odigeo.Utils.parseRememberMeCookie(rememberMeCookie).isMembership === 'true';
    } else {
        isLogged = true;
        isPrime = !Odigeo._.isNull(userData.membershipInfoDTO.membershipDTO);
        isActive = userData.status === 'ACTIVE';
    }

    return {
        isLogged,
        isPrime,
        isActive,
    };
};

const getUserAreaPage = (pageName) => {
    const userAreaPages = [
        'membership_mytrips_reactivation',
        'membership_retention',
        'membership_cancellation',
        'membership_cancellation_request',
        'right_of_withdrawal',
        'remediation_request',
        'remediation_process',
        'sahome',
        'btform',
        'home',
        'register',
        'loginexpired',
        'mytripslogin',
        'mytrips',
        'tripdetails',
        'frequentpassengers',
        'accountpreferences',
        'accountcreditcards',
        'support-center',
    ];
    return userAreaPages.find((page) => pageName.includes(page));
};

const normalizeTrainSearch = (value) => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') return value.toLowerCase() === 'true';
    return false;
};

module.exports = Backbone.Model.extend({
    defaults: {
        legs: null,
        dates: null,
        checkingDates: null,
        passengers: null,
        titleKey: null,
        userInfo: {},
    },
    initialize() {
        var currentSearchModel = currentSearchSingletonModel.getInstance();
        this.listenTo(currentSearchModel, 'change', Odigeo._.bind(this.updateSearch, this));
    },
    updateSearch() {
        const searchParameters = Odigeo._.extend({}, Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')));
        this.set({
            ...getUpdatedModel(searchParameters),
            page: this.get('page') || Odigeo._.get(Odigeo.Router, 'mostRecentCalled.name', null),
            userInfo: this.get('userInfo'),
            titleKey: this.get('titleKey'),
            trainSearch: normalizeTrainSearch(searchParameters.trainSearch),
        });
    },
    update(data) {
        const {page, userData = null, of2UserData = null} = data;
        const searchParameters = Odigeo._.extend({}, Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')));
        const userAreaPage = getUserAreaPage(page);
        if (Odigeo._.get(searchParameters, 'searchSegments.length') > 0) {
            this.set(Object.assign({}, getUpdatedModel.call(this, searchParameters), {
                page,
                userInfo: getUserInfo(userData),
                trainSearch: normalizeTrainSearch(searchParameters.trainSearch),
            }));
        } else if (Odigeo.AB.getSupportAreaNewExperience === 3 && page?.includes('sahome') && of2UserData) {
            this.set(Object.assign({}, {page: 'sahome', of2UserData, userInfo: getUserInfo(userData)}));
        } else if (userAreaPage) {
            this.set(Object.assign({}, {titleKey: userAreaPage + 'Title', page: userAreaPage, userInfo: getUserInfo(userData)}));
        }
    },
});
